import styled from 'styled-components';

export const EditableInputContainer = styled.div`
  width: 100%;
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 20px;
  color: ${({theme}) => theme.black};
  padding: 11px 16px;
  border-radius: 8px;
  background: ${({theme}) => theme.grayExtraLight};
  border: 1px solid ${({theme}) => theme.gray};
  transition: all 300ms ease-in-out;
  margin-top: 6px;
  &:focus {
    border: 1px solid ${({theme}) => theme.accent};
  }

  ._4GdcU {
    border: unset !important;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    margin: unset !important;
    display: flex;
    align-items: center;
    justify-content: start;
    padding: unset !important;
    &:hover{
      border: none !important;
      background: none;
      cursor: pointer;
    }
  }

  ._IYz6Z{
    display: flex;
    align-items: center;
    button {
      width: 20px !important;
      height: 20px !important;
      svg {
        width: 15px;
        height: 15px;
        path {
          fill: ${({theme}) => theme.gray}
        }
      }
    }
  }

  ._i5--j {
    width: 100%;
    display: flex;
    scrollbar-width: thin;
    margin: unset !important;
    padding: unset !important;
    border: unset !important;
    font-style: normal !important;
    font-weight: 400 !important;
    font-size: 14px !important;
    line-height: 20px !important;
    color: ${({theme}) => theme.black} !important;
    background: ${({theme}) => theme.grayExtraLight} !important;
  }

  ._G0k44 {
    overflow-y: auto;
    transition: background 0.2s ease;
  }
  
`
